import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
// import { UserModel } from '../../types/models/UserModel';
import { UserModelN } from '../../types/models/UserModelN';

// interface UserResponse {
//   users: UserModel[]; // Change to ApplicationModel array instead of any[]
//   totalCount: number;
// }

interface UserNewResponse{
  users: UserModelN[];
  totalCount: number;
}

// interface UserEmailResponse{
//   emails: string[];
//   totalCount:number;
// }

interface UsersState {
  data: UserModelN[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

const initialState: UsersState = {
  data: [],
  totalRecords: 0,
  currentPage: 1,
  loading: false,
  error: null,
  status: null
};

const API_URL = '/User';

export const fetchUsers = createAsyncThunk<UserNewResponse, { page: number; numberOfRecord: number; filters: { company: any[]; roles: any[]; status: any[],search:string };  sortColumn?: string;sortOrder?: 'asc' | 'desc'; }>(
  'users/fetchUsers',
  async ({ page, numberOfRecord, filters,sortColumn = '', sortOrder = 'asc'  }) => {
    try {
      // Construct the query string with filters
      const { company, roles, status,search } = filters;

      // Adding filter parameters to the API request URL
      const companyFilter = company.length > 0 ? `&company=${company.join(',')}` : '';
      const roleFilter = roles.length > 0 ? `&roles=${roles}` : '';
      const statusFilter = status.length > 0 ? `&status=${status.join(',')}` : '';
      const searchFilter = `&search=${search}`;
      const url = `${API_URL}/GetAll?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}${companyFilter}${roleFilter}${statusFilter}${searchFilter}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&userTimeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;

      const response = await nexapi.post(url);
      const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          users: data.data, // The list of users
          totalCount: data.totalCount, // The total count of users
        };
      } else {
        console.error('Invalid API Response:', data);
        return { users: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

export const fetchUserEmail = createAsyncThunk<UserNewResponse, {id:string;companyCode:string}>(
  'users/fetchUserEmail',
  async ({ id,companyCode }) => {
    try {

      const url = `${API_URL}/GetAllUserEmails?roleId=${id}&companyCode=${companyCode}`;

      const response = await nexapi.post(url);
      const data = response.data;

      if (Array.isArray(data?.data)) {
        return {
          users: data.data, // The list of users
          totalCount: data.totalCount, // The total count of users
        };
      } else {
        console.error('Invalid API Response:', data);
        return { users: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);


// Async thunk for fetching users
// export const fetchUsers = createAsyncThunk<UserResponse, { page: number; numberOfRecord: number }>(
//   'users/fetchUsers',
//   async ({ page, numberOfRecord }) => {
//     try {
//       const response = await nexapi.post(API_URL + `/GetAll?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}`);
//       const data = response.data;

//       if (Array.isArray(data?.data)) {
//         return {
//           users: data.data, // The list of users
//           totalCount: data.totalCount, // The total count of users
//         };
//       } else {
//         console.error("Invalid API Response:", data);
//         return { users: [], totalCount: 0 }; // Return a fallback structure
//       }
//     } catch (error) {
//       console.error("API Call Failed:", error);
//       throw error;
//     }
//   }
// );


export const fetchUsersByRoleId = createAsyncThunk<UserNewResponse, { id: string, page: number; numberOfRecord: number }>(
  'users/fetchUsersByRoleId',
  async ({ id, page, numberOfRecord }) => {
    try {
      const response = await nexapi.post(API_URL + `/GetUsersByRoleId?roleId=${id}&pagination=true&page=${page}&numberOfRecord=${numberOfRecord}`);
      const data = response.data;

      if (Array.isArray(data?.data)) {
        return {
          users: data.data, // The list of users
          totalCount: data.totalCount, // The total count of users
        };
      } else {
        console.error("Invalid API Response:", data);
        return { users: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/deleteUser', 
  async ({ id, reason }: { id: any; reason: any }) => { 
  try {
  await nexapi.delete(`${API_URL}/DeleteUser?id=${id}&reason=${reason}`);
  return id;
} catch (error) {
  return error.message
}
});

const requestsSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.users;
        state.status = 'succeeded';
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch users';
      })
      .addCase(deleteUser.fulfilled, (state, action:any) => {
              state.data = state.data.filter((app) => app.id !=  action.payload);
              state.status = 'succeeded';
      })
      .addCase(fetchUsersByRoleId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.users;
        state.status = 'succeeded';
      })
      .addCase(fetchUserEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.users;
        state.status = 'succeeded';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default requestsSlice.reducer;
